import { post ,get} from './http'
const baseUrl = '/api/capwhale/live/imagetext'
//web端  app端  

export const getLiveInfo = v => post(`${baseUrl}/findStartLiveInfo`, v.data, v.success, v.error); //根据直播状态查询对应直播信息(直播中)

export const getLiveInfoByPage = v => post(`${baseUrl}/findStartLiveInfoMore`, v.data, v.success, v.error); //根据直播状态查询对应直播信息(直播中-上拉分页)

export const getEndInfo = v => post(`${baseUrl}/findEndLiveInfo`, v.data, v.success, v.error); //获取图文/海报直播内容(已结束分页查询)

export const getPendingInfo = v => post(`${baseUrl}/findNotStartLiveInfo`, v.data, v.success, v.error); //根据直播状态查询对应直播信息(直播未开始)

export const getColumnList = v => post(`${baseUrl}/getLiveInfo`, v.data, v.success, v.error); //PC端首页查询

export const uploadPraiseinfo = v => post(`${baseUrl}/uploadPraiseinfo`, v.data, v.success, v.error); //  更新直播点赞

export const getMediaNewsList = v => get(`/api/wlive/media/getWebCwLivecontentMediainfo/${v.liveinnerid}/${v.currentPage}/${v.pageSize}`, v.data, v.success, v.error); //  获取wap媒体播报

export const saveUserLiveInfo = v => post(`${baseUrl}/saveLiveBespokeinfo`, v.data, v.success, v.error); //  提交预约直播

export const getMPJSAPIData = v => post('/api/wlive/getMPJSAPIData', v.data, v.success, v.error); //  获取微信JSAPI需要显示的数据

export const getIndexBanner = v => post(`${baseUrl}/getLiveToBanner`, v.data, v.success, v.error); //  直播首页banner查询

export const getIndexList = v => post(`${baseUrl}/getLiveToRecomm`, v.data, v.success, v.error); //  直播首页list查询

export const getIndexSearch = v => post(`${baseUrl}/findLiveByParam`, v.data, v.success, v.error); //  直播首页综合查询

export const getPoster = v => post(`${baseUrl}/getLiveEventposter`, v.data, v.success, v.error); //  获取海报
//  全部直播
export const getIndexLiveByAll = v => post(`${baseUrl}/getIndexLiveByAll`, v.data, v.success, v.error);
//  直播banner 财经投资
export const getLiveToBannerByPC = v => post(`${baseUrl}/getLiveToBannerByPC`, v.data, v.success, v.error);
//  直播  专题视频列表
export const getVedioByTopic = v => post(`${baseUrl}/getVedioByTopic`, v.data, v.success, v.error);
//  直播  专题视频列表
export const getAllVideo = v => post(`${baseUrl}/getAllVideo`, v.data, v.success, v.error);
//  直播  专题视频详情
export const getVedioDetailByTopic = v => post(`${baseUrl}/getVedioDetailByTopic`, v.data, v.success, v.error);
//  直播  发布评论
export const updateCommentInfo = v => post(`${baseUrl}/updateCommentInfo`, v.data, v.success, v.error);
//  直播  评论列表
export const getCommentList = v => post(`${baseUrl}/getCommentList`, v.data, v.success, v.error);
//  直播  推荐列表
export const getRecommendVedioByTopic = v => post(`${baseUrl}/getRecommendVedioByTopic`, v.data, v.success, v.error);


